module.exports = __webpack_public_path__ + "static/media/click-sound.0b5c6c69.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/click-sound.wav
// module id = 246
// module chunks = 0